import { parseUtcInstant } from './time';

/**
 * Back-compat wrapper for existing imports. New code should use parseUtcInstant.
 */
export function parseBackendDateTime(value: unknown): Date | null {
  return parseUtcInstant(value);
}

